import { createFileRoute } from "@tanstack/react-router";

import StaffSidebar from "@/components/Staff/StaffSidebar";

const Component = () => {
  const { userUuid } = Route.useParams();

  return <StaffSidebar userUuid={userUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/staff/$userUuid")({
  component: Component,
});
